import HulahoopLogoMini from "@/assets/hulahoop-logo-mini-pos.svg";
import HulahoopLogo from "@/assets/hulahoop-logo-pos.svg";
import { PanelLeft } from "lucide-react";
import { getSidebarTheme, isDarkVariant, type SidebarVariant } from "./sidebarTheme";
import { cn } from "@/utils";

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
  variant?: SidebarVariant;
}

export const SidebarHeader = ({
  isCollapsed,
  onToggle,
  variant = "default",
}: SidebarHeaderProps) => {
  const theme = getSidebarTheme(variant);
  const logoFilterClass = theme.logoFilter ? cn("filter", theme.logoFilter) : "";
  const isDark = isDarkVariant(variant);

  return (
    <div
      className={cn("p-4 flex items-start justify-between", theme.badge ? "min-h-[4rem]" : "h-14")}
    >
      <div className="flex items-center overflow-hidden">
        {isCollapsed ? (
          <div className="flex flex-col items-center">
            <img
              src={HulahoopLogoMini || "/placeholder.svg"}
              alt="Hulahoop"
              className={cn("h-8 transition-opacity duration-200", logoFilterClass)}
            />
            {theme.badge && (
              <span
                className={cn(
                  "mt-1 px-1.5 py-0.5 text-3xs font-medium uppercase tracking-wide rounded",
                  theme.badgeStyle || "bg-border-secondary text-text-secondary",
                )}
              >
                {theme.badge}
              </span>
            )}
          </div>
        ) : (
          <div className="flex flex-col">
            <img
              src={HulahoopLogo || "/placeholder.svg"}
              alt="Hulahoop"
              className={cn("h-10 transition-opacity duration-200", logoFilterClass)}
            />
            {theme.badge && (
              <span
                className={cn(
                  "mt-1 ml-1 px-1.5 py-0.5 text-3xs font-medium uppercase tracking-wide rounded w-fit",
                  theme.badgeStyle || "bg-border-secondary text-text-secondary",
                )}
              >
                {theme.badge}
              </span>
            )}
          </div>
        )}
      </div>

      {!isCollapsed && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          className={cn(
            "p-1.5 rounded-md hover:shadow-sm hover:scale-102 transition-all duration-200 opacity-100",
            isDark ? theme.hover : "hover:bg-hover-secondary",
          )}
        >
          <PanelLeft size={18} className={theme.textSecondary} />
        </button>
      )}
    </div>
  );
};
